import { UseFormGetValues } from 'react-hook-form'
import { NotifyEventType } from 'validator/notify_event_validator'
import { INotificationFeedBackHelperProps } from './components/modals/NotificationConfirmation'
import { IVariableReducer } from 'types/variable'
import { ILocationReducer } from 'types/location'
import { ISectorReducer } from 'types/sector'
import { featureFlags } from 'config/featureFlags'
/**
 * Tabela com a distribuição de regras de obrigatoriedade currentStepSelected do processo de tratamento no modelo antigo
 */
export const olderRulesToShowStepsNotifcationTreatment = [
    ['Grau do Dano', 'Risco de Imagem', 'Ishikawa', 'Protocolo de Londres', 'Matriz de Responsabilização', 'Plano de Ação'],
    ['Circunstância Notificável', 'Não', 'Facultativo', 'Facultativo', 'Facultativo', 'Facultativo'],
    ['Circunstância Notificável', 'Sim', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório'],
    ['Near Miss', 'Não', 'Facultativo', 'Facultativo', 'Facultativo', 'Facultativo'],
    ['Near Miss', 'Sim', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório'],
    ['Sem Dano', 'Não', 'Obrigatório', 'Facultativo', 'Facultativo', 'Obrigatório'],
    ['Sem Dano', 'Sim', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório'],
    ['Dano Leve', 'Não', 'Obrigatório', 'Facultativo', 'Obrigatório', 'Obrigatório'],
    ['Dano Leve', 'Sim', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório'],
    ['Dano Moderado', 'Não', 'Obrigatório', 'Facultativo', 'Obrigatório', 'Obrigatório'],
    ['Dano Moderado', 'Sim', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório'],
    ['Dano Grave', 'Não', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório'],
    ['Dano Grave', 'Sim', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório'],
    ['Óbito', 'Não', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório'],
    ['Óbito', 'Sim', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório']
]
/**
 * Tabela com a distribuição de regras de obrigatoriedade currentStepSelected do processo de tratamento calculando a pontuaçãc com u_probability_occurence
 */
export const probabilityOccurrenceRulesMapper = [
    ['Grau do dano', 'Pontuação do dano', 'Risco de imagem', 'Pontuação', 'Pontuação qualidade', 'Ishikawa', 'Protocolo de londres', 'Matriz de responsabilidade', 'Plano de ação'],
    ['Circunstância Notificável', '1', 'não', 'verde', '4>=', 'Dispensável', 'Facultativo', 'Facultativo', 'Dispensável'],
    ['Circunstância Notificável', '1', 'não', 'amarelo', '4<=10', 'Facultativo', 'Facultativo', 'Facultativo', 'Facultativo'],
    ['Circunstância Notificável', '1', 'não', 'vermelho', '>10', 'Obrigatório', 'Facultativo', 'Facultativo', 'Obrigatório'],
    ['Near Miss', '1', 'não', 'verde', '4>=', 'Dispensável', 'Facultativo', 'Facultativo', 'Dispensável'],
    ['Near Miss', '1', 'não', 'amarelo', '4<=10', 'Facultativo', 'Facultativo', 'Facultativo', 'Facultativo'],
    ['Near Miss', '1', 'não', 'vermelho', '>10', 'Obrigatório', 'Facultativo', 'Facultativo', 'Obrigatório'],
    ['Incidente sem dano', '1', 'não', 'verde', '4>=', 'Dispensável', 'Facultativo', 'Facultativo', 'Dispensável'],
    ['Incidente sem dano', '1', 'não', 'amarelo', '4<=10', 'Facultativo', 'Facultativo', 'Facultativo', 'Facultativo'],
    ['Incidente sem dano', '1', 'não', 'vermelho', '>10', 'Obrigatório', 'Facultativo', 'Facultativo', 'Obrigatório'],
    ['Incidente com dano Leve', '2', 'não', 'verde', '4>=', 'Dispensável', 'Facultativo', 'Obrigatório', 'Dispensável'],
    ['Incidente com dano Leve', '2', 'não', 'amarelo', '4<=10', 'Facultativo', 'Facultativo', 'Obrigatório', 'Facultativo'],
    ['Incidente com dano Leve', '2', 'não', 'vermelho', '>10', 'Obrigatório', 'Facultativo', 'Obrigatório', 'Obrigatório'],
    ['Incidente com dano moderado', '3', 'não', 'verde', '4>=', 'Dispensável', 'Facultativo', 'Obrigatório', 'Dispensável'],
    ['Incidente com dano moderado', '3', 'não', 'amarelo', '4<=10', 'Facultativo ', 'Facultativo', 'Obrigatório', 'Facultativo'],
    ['Incidente com dano moderado', '3', 'não', 'vermelho', '>10', 'Obrigatório', 'Facultativo', 'Obrigatório', 'Obrigatório'],
    ['Incidente com dano grave', '4', 'não', 'verde', '4>=', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório'],
    ['Incidente com dano grave', '4', 'não', 'amarelo', '4<=10', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório'],
    ['Incidente com dano grave', '4', 'não', 'vermelho', '>10', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório'],
    ['Incidente com óbito', '5', 'não', 'verde', '4>=', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório'],
    ['Incidente com óbito', '5', 'não', 'amarelo', '4<=10', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório'],
    ['Incidente com óbito', '5', 'não', 'vermelho', '>10', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório'],
    ['Circunstância Notificável', '', 'sim', '', '', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório'],
    ['Near Miss', '', 'sim', '', '', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório'],
    ['Incidente sem dano', '', 'sim', '', '', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório'],
    ['Incidente com dano Leve', '', 'sim', '', '', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório'],
    ['Incidente com dano moderado', '', 'sim', '', '', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório'],
    ['Incidente com dano grave', '', 'sim', '', '', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório'],
    ['Incidente com óbito', '', 'sim', '', '', 'Facultativo', 'Obrigatório', 'Obrigatório', 'Obrigatório']
]

export const severityProbalityOccurenceInfoMapper = [
    {
        probabilidade: 'Probabilidade',
        eventoSemDano: 'Evento sem dano',
        danoLeve: 'Dano leve',
        danoModerado: 'Dano moderado',
        danoGrave: 'Dano grave',
        obito: 'Óbito'
    },
    {
        probabilidade: 'Frequente',
        eventoSemDano: '5',
        danoLeve: '10',
        danoModerado: '15',
        danoGrave: '20',
        obito: '25'
    },
    {
        probabilidade: 'Ocasional',
        eventoSemDano: '4',
        danoLeve: '8',
        danoModerado: '12',
        danoGrave: '16',
        obito: '20'
    },
    {
        probabilidade: 'Incomum',
        eventoSemDano: '3',
        danoLeve: '6',
        danoModerado: '9',
        danoGrave: '12',
        obito: '15'
    },
    {
        probabilidade: 'Remoto',
        eventoSemDano: '2',
        danoLeve: '4',
        danoModerado: '6',
        danoGrave: '8',
        obito: '10'
    },
    {
        probabilidade: 'Nunca',
        eventoSemDano: '1',
        danoLeve: '2',
        danoModerado: '3',
        danoGrave: '4',
        obito: '5'
    }
]


export const probalityOccurenceInfoMapper = [
    {
        label: 'Nunca',
        probality: 1,
        info: 'Nunca ocorreu'
    },
    {
        label: 'Remota',
        probality: 2,
        info: 'Dificilmente ocorre (2 vezes no mês)'
    },
    {
        label: 'Incomum',
        probality: 3,
        info: 'É possível ocorrer (3 vezes no mês)'
    },
    {
        label: 'Ocasional',
        probality: 4,
        info: 'Ocorre ocasionalmente, o dano pode ocorrer com relativa faciliadde (4 vezes no mês)'
    },
    {
        label: 'Frequente',
        probality: 5,
        info: 'Provavelmente ocorrerá novamente de imediato ou aós breve período de tempo (5 ou mais vezes no mês)'
    }
]


export const damageLevelInfoMapper = [
    {
        serverLabel: 'Circunstância notificável',
        level: 'Circunstância notificável',
        info: 'Circunstância em que houve potencial significativo para o dano, mas o incidente não ocorreu (Exemplo: um desfibrilador presente na sala de emergência que não funciona, apesar de não ter sido necessário o seu uso)'
    },
    {
        serverLabel: 'Near miss (Quase erro)',
        level: 'Near miss (Quase erro)',
        info: 'Evento de segurança que não atinge o paciente por conta de uma barreira efetiva (quando é interceptado antes), portanto o evento não acontece. (ex.: unidade de sangue incompatível conectada ao doente, percebida antes da infusão)'
    },
    {
        serverLabel: 'Incidente sem dano',
        level: 'Incidente sem dano',
        info: 'Evento que ocorreu a um paciente, mas não chegou a resultar em dano. (ex.: unidade de sangue incompatível conectada ao doente, infundida, porém sem reação ao doente)'
    },
    {
        serverLabel: 'Incidente com dano leve',
        level: 'Incidente com dano Leve',
        info: 'Evento que resultou em dano ao paciente, com ocorrência de sintomas leves, perda de função ou danos mínimos / moderados, mas com duração rápida, e apenas foram necessárias intervenções mínimas (ex.: observação extra, investigação, revisão de tratamento, tratamento leve)'
    },
    {
        serverLabel: 'Incidente com dano moderado',
        level: 'Incidente com dano Moderado',
        info: 'Evento que resultou em dano ao paciente, com ocorrência de sintomas, com necessidade de intervenção, aumento do tempo de internação, com dano ou perda de função de forma permanente ou de longo prazo.'
    },
    {
        serverLabel: 'Incidente com dano grave',
        level: 'Incidente com dano Grave',
        info: 'Evento que resultou em dano ao paciente, com ocorrência de sintomas, com necessidade de intervenção para suporte avançado à vida, ou intervenção clínica / cirúrgica de grande porte, causando diminuição da expectativa de vida, com grande dano ou perda de função permanente ou de longo prazo.'
    },
    {
        serverLabel: 'Incidente com ÓBITO',
        level: 'Incidente com Óbito',
        info: 'Evento que resultou em dano ao paciente, e dentro das probabilidades, em curto prazo o evento causou ou acelerou a morte.'
    }
]

export function getDamageLevelInfoMapper() {
    if (featureFlags.activeCircumstanceNotifiable) {
        return damageLevelInfoMapper
    }

    return damageLevelInfoMapper.filter(
        item => item.serverLabel !== 'Circunstância notificável'
    )
}

export const damageLevelInfoGetRoundedStyle = (idx: number, length: number) => {
    if (idx === 0) return 'rounded-t-lg'
    if (idx === length - 1) return 'rounded-b-lg'
    return ''
}

export const feedBackNotificationMapper = (
    formValues: NotifyEventType,
    variableSelector: IVariableReducer,
    locationSelector: ILocationReducer,
    sectorSelector: ISectorReducer,
    thereIsFile: boolean,
) => {
    const incidentSector = formValues.incident_sector
    const reporterSector = formValues.reporter_sector
    const locationIncident = formValues.location_incident
    const dmgValue = formValues.damage_level
    const selectedDamageValue = variableSelector.variablesListDamageLevel
        ?.slice(1)
        .find((l) => l?.value === dmgValue)?.label
    const locationIncidentValue = locationSelector?.locationsList?.find(
        (l) => l?.sys_id === locationIncident
    )?.name
    const sectorSelectorValue = sectorSelector?.sectorsList?.find(
        (l) => l?.sys_id === incidentSector
    )?.u_name
    const reporterSectorValue = sectorSelector?.sectorsList?.find(
        (l) => l?.sys_id === reporterSector
    )?.u_name

    const patientsInvolvedValues = variableSelector?.variablesList?.find((item) => item?.label === "Number patients involved") as any

    const result = [
        {
            keyText: 'Título da notificação',
            valueText: formValues.incident_title
        },
        {
            keyText: 'Data da ocorrência',
            valueText: formValues.date_incident?.toLocaleDateString()
        },
        {
            keyText: 'Classificação do Incidente',
            valueText: selectedDamageValue
        },
        {
            keyText: 'Está relacionado a algum paciente',
            valueText:
                formValues.involves_patient &&
                    formValues.u_number_patients_involved === patientsInvolvedValues?.choices?.[1]?.value
                    ? 'SIM'
                    : formValues.involves_patient &&
                        formValues.u_number_patients_involved === patientsInvolvedValues?.choices?.[2]?.value
                        ? 'SIM - 2 ou mais'
                        : 'NÃO'
        },
        {
            keyText: 'Multiplicador',
            valueText:
                formValues.u_number_patients_involved === patientsInvolvedValues?.choices?.[2]?.value
                    ? formValues.u_notification_multiplier
                    : ''
        },
        ...printPatientData(formValues),
        {
            keyText: 'Unidade',
            valueText: locationIncidentValue
        },
        {
            keyText: 'Setor notificado',
            valueText: sectorSelectorValue
        },
        {
            keyText: 'Turno',
            valueText: getTurnLabelByValue(formValues.shift_incident)
        },
        {
            keyText: 'Setor notificante',
            valueText: reporterSectorValue
        },
        {
            keyText: 'Notificante',
            valueText: formValues.notification_type_toggle
                ? formValues.reporter_name
                : 'Anônimo'
        },
        {
            keyText: 'Anexo',
            valueText: thereIsFile
                ? 'SIM'
                : 'NÃO'
        },
    ]

    if (formValues.u_number_patients_involved === patientsInvolvedValues?.choices?.[2]?.value) {
        delete result[5]
        delete result[6]
        delete result[7]
    }
    if (
        !formValues.involves_patient ||
        formValues.u_number_patients_involved === patientsInvolvedValues?.choices?.[1]?.value
    ) {
        delete result[4]
    }
    return result
}
const printPatientData = (formValues: NotifyEventType) => {
    const involvesPatient = formValues.involves_patient
    if (!involvesPatient) {
        return []
    }
    return [
        {
            keyText: 'Iniciais do paciente',
            valueText: formValues.patient_initials
        },
        {
            keyText: 'Data de Nascimento',
            valueText: formValues.patient_date_of_birth?.toLocaleDateString()
        },
        {
            keyText: 'Documento',
            valueText: `${formValues.document_type} / ${formValues.document_number}`
        }
    ]
}
const getTurnLabelByValue = (value: string) => {
    const mapper = {
        not_known: 'Não informado',
        nighttime: 'Noturno  (19h - 6h59)',
        daytime: 'Diurno (7h - 18h59)'
    }
    return mapper[value]
}
